import { configureStore } from "@reduxjs/toolkit";
import caseSlice from "./slices/case/case.slice";
import formSliceReducer from "./slices/form.slice";
import clientLensSlice from "./slices/clientLens/clientLens.slice";
import lensEditorSlice from "./slices/lensEditor/lensEditor.slice";
import sessionSlice from "./slices/session/session.slice";
import intakeViewerSlice from "./slices/intakeViewer/intakeViewer.slice";
import lensRunSlice from "./slices/lensRun/lensRun.slice";
import invoiceSlice from "./slices/invoice/invoice.slice";
import loaderErrorSlice from "./slices/loader-error.slice";
import clientSlice from "./slices/client/client.slice";

// Note: If circular dependency issues arise, try exporting only the 'reducer' rather
// than the entire slice.
// https://redux-toolkit.js.org/usage/usage-guide#exporting-and-using-slices
// https://github.com/reduxjs/redux-toolkit/issues/1126#issuecomment-853804161
const store = configureStore({
  reducer: {
    // case slice
    case: caseSlice.reducer,
    // lens slice
    clientLens: clientLensSlice.reducer,
    lensform: formSliceReducer,
    // client slice
    client: clientSlice.reducer,
    // misc slices
    invoice: invoiceSlice.reducer,
    session: sessionSlice.reducer,
    intakeviewer: intakeViewerSlice.reducer,
    lensRun: lensRunSlice.reducer,
    loaderError: loaderErrorSlice.reducer,
    lensEditor: lensEditorSlice.reducer,
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
